/** URL parameters of the Year, Quarter and Month selects of a Data views filter bar. */
export const PERIOD_PARAMS = ['year', 'quarter', 'month'] as const;

const pad = (n: number) => String(n).padStart(2, '0');
const day = (year: number, month: number) =>
  month > 12 ? `${year + 1}-01-01` : `${year}-${pad(month)}-01`;

/**
 * The period of the Year, Quarter and Month selects as `[from, to)` first days of months, or null
 * without a year. A month wins over its quarter.
 */
export function periodRange(params: URLSearchParams): [string, string] | null {
  const year = Number(params.get('year'));
  if (!Number.isInteger(year) || year <= 0) return null;
  const month = Number(params.get('month'));
  const quarter = Number(params.get('quarter'));
  if (month >= 1 && month <= 12) return [day(year, month), day(year, month + 1)];
  if (quarter >= 1 && quarter <= 4) return [day(year, quarter * 3 - 2), day(year, quarter * 3 + 1)];
  return [day(year, 1), day(year + 1, 1)];
}
